import axios from "axios";
import { API_URL } from "../config/constant";

/**
 * Initiates MoneyView application.
 * @param {Object} mvJsonData - The payload for MoneyView.
 * @param {Function} navigate - React router navigate function.
 * @param {Function} handleFormSubmit - Fallback submit handler.
 * @param {Function} setIsDisableBtn - State setter for disabling button.
 * @param {Function} setDisplay - State setter for display/loading.
 */
export function initiateMoneyViewApplication(
  mvJsonData,
  navigate,
  handleFormSubmit,
  setIsDisableBtn,
  setDisplay
) {
  axios
    .post(API_URL + "mv/create-lead", { mvJsonData: mvJsonData })
    .then((res) => {
      const { data } = res;
      if (data?.status === "success") {
        // Navigate to congratulations page with leadId as query param
        navigate(`/congratulations-mv?leadId=${data?.leadId}`);
      } else {
        handleFormSubmit();
      }
      setIsDisableBtn(false);
      setDisplay("none");
    })
    .catch((e) => {
      console.log(e);
      setIsDisableBtn(false);
      setDisplay("none");
    });
}
